module.exports = __webpack_public_path__ + "img/vertical_6_1_9005.0d904beb.png";